import React from "react";
import {Divider, Table, TableBody, TableCell, TableHead, TableRow, View} from "@aws-amplify/ui-react";
import styles from "./index.module.css";
import {useNavigate} from "react-router-dom";

const LessonsList = ({courseId = 0, lessons = [], currentLessonId = {}}) => {
  const navigate = useNavigate();

  const getListTitle = () => {
    switch (courseId) {
      case 3199:
        return "Video";
      case 3200:
      case 3201:
        return "Articoli";
      default:
        return "";
    }
  }

  return lessons.length > 0 ?
    (
      <View
        width="100%"
        padding="16px"
        className={styles.siderView}
      >
        <Table
          size="small"
          className={styles.lessonsTable}
        >
          <TableHead>
            <TableRow>
              <TableCell
                as="th"
                fontWeight={900}
                className={styles.lessonsTableCellHead}
              >
                {getListTitle()}
              </TableCell>
            </TableRow>
          </TableHead>
          <Divider border="1px solid #9381ff" />
          <TableBody>
            {
              lessons.map((lesson, i) => {
                const {
                  id: lessonId = 0,
                  title: lessonTitle = ""
                } = lesson || {};

                const cellClassNames = [styles.lessonsTableCell]

                if (lessonId === currentLessonId) {
                  cellClassNames.push(styles.lessonsTableCellActive)
                }

                return (
                  <TableRow key={`lessons_table_row_${lessonId}`}>
                    <TableCell
                      style={i >= lessons.length - 1 ? {borderBottom: "none"} : {}}
                      onClick={() => navigate(`/corsi/${courseId}/lezioni/${lessonId}`)}
                      className={cellClassNames.join(" ")}
                    >
                      {lessonTitle}
                    </TableCell>
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>
      </View>
    ) :
    null
}

export default LessonsList;